<template>
  <app-modal modal-id="leson-modal"
             modal-size="large"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_leson") : $t("add_leson") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/lesons`">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_name") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="text"
                  :placeholder="$t('enter_name')"
                  name="name"
                  v-model="formData.name"
                  :required="true"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-row">
            <label class="col-sm-3 mb-0 d-flex align-items-center">{{ $t("set_schedule") }}</label>
            <div class="col-sm-9">
                <div class="row">
                    <div class="mb-0 col-1 d-flex align-items-center">
                        <label>{{ $t("gantt_date_start") }}</label>
                    </div>
                  <div class="col-5">
                    
                    <app-input
                      type="date"
                      :popover-position="'bottom-start'"
                      :placeholder="$t('start_date')"
                      :required="true"
                      v-model="formData.started_at"
                      @input="setEndDateAsStartDate"
                    />
                  </div>
                  <div class="mb-0 col-1 d-flex align-items-center">
                        <label>{{ $t("gantt_date_end") }}</label>
                    </div>
                  <div class="col-5">
                    <app-input
                      type="date"
                      :popover-position="'bottom-start'"
                      :min-date="formData.started_at"
                      :required="true"
                      :placeholder="$t('end_date')"
                      v-model="formData.ended_at"
                    />
                  </div>
                </div>

                
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{ $t("gantt_collab") }}</label>
            <div class="col-sm-9">
              <app-input
                type="multi-select"
                :list="ownerList"
                :required="true"
                list-value-field="full_name"
                v-model="formData.collaborator"
                :is-animated-dropdown="true"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_rest") }}</label>
            </div>
            <div class="col-6">
              <div class="row">
                <div 
                :class="formData.rest_id ? 'col-10 pr-0' : 'col-12'">
                  <app-input
                  type="search-select"
                  list-value-field="name"
                  :placeholder="$t('enter_gantt_rest')"
                  :list="personList"
                  v-model="formData.rest_id"
              />
              
                </div>
                <div class="col-2 d-flex align-items-center" v-if="formData.rest_id">
                  <a href class="text-muted leson-delete"
                                                                @click.prevent="clearRest()">
                                                                <app-icon name="trash-2" width="20px" height="20"/>
                                                            </a>
                </div>

              </div>
              
            </div>
            <div class="col-3">
              <app-input
                  type="number"
                  :placeholder="$t('enter_price')"
                  name="price"
                  v-model="formData.price"
                  :error-message="$errorMessage(errors, 'price')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_status") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input type="radio"
												   list-value-field="name"
												   :list="statusList"
												   v-model="formData.status_id"
												   :error-message="$errorMessage(errors, 'status_id')"/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_desc") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="textarea"
                  :placeholder="$t('enter_dec')"
                  name="description"
                  v-model="formData.description"
                  :error-message="$errorMessage(errors, 'description')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <a href class="" @click.prevent="openChange()">
                {{ $t('gantt_change_date') }}
              </a>
            </div>
            <div class="col-2 show-change"
            :class="{'show-change-active': showChange}">
              <app-input
                  type="number"
                  :placeholder="$t('enter_day')"
                  name="price"
                  v-model="formData.day"
              />
            </div>
            <div class="col-7 show-change d-flex align-items-center"
            :class="{'show-change-active': showChange}">
              {{ $t("gantt_change_about") }}
            </div>
          </div>
        </div>

        
         
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";
import { collect } from "@app/Helpers/Collection";
import moment from "moment";

export default {
  name: "LesonModal",
  mixins: [FormSubmitMixin],
  props: {
    ganttId: Number,
    start: String,
    end: String,
  },
  data() {
    return {
      dataLoaded: true,
      showChange:false,
      countryList: [],
      formData: {
        collaborator: [],
        created_by: user.id,
        //started_at: moment(start, "DD.MM.YYYY").format('DD-MM-YYYY'),
        started_at: new Date(),
        ended_at: new Date(),
        status_id: 14,
    },
      addEditData: {
        
      },
      statusList: [
        {
          id: 14,
          name: this.$t('gantt_todo')
        },
        {
          id: 15,
          name: this.$t('gantt_done')
        },
        {
          id: 16,
          name: this.$t('gantt_lose')
        },

      ],
     
     
    };
  },
  computed: {
    ...mapGetters({
      ownerList: "getOwner",
      personList: "getPersonRest",
	 
	 
    }),

  },
  methods: {
    clearRest(){
      this.formData.rest_id = null;
    },
    openChange(){
      if(this.showChange){
        this.showChange = false;
      }else{
        this.showChange = true;
      }
    },
    setEndDateAsStartDate() {

// please no need to change this formation of date,
// it is just use for check logic

let s = moment(moment(this.formData.started_at).format("YYYY-MM-DD")),
  e = moment(moment(this.formData.ended_at).format("YYYY-MM-DD")),
  diff = e.diff(s, "days");

if (this.dataLoaded && diff < 0){
  this.formData.ended_at = this.formData.started_at;
}
},
    
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
    
      


      this.addEditData.name = this.formData.name;
      this.addEditData.created_by = this.formData.created_by;
      this.addEditData.collaborator = this.formData.collaborator;
      this.addEditData.started_at = moment(this.formData.started_at).format("YYYY-MM-DD");
      this.addEditData.ended_at = moment(this.formData.ended_at).format("YYYY-MM-DD");
      this.addEditData.price = this.formData.price;
      this.addEditData.rest_id = this.formData.rest_id;
      this.addEditData.status_id = this.formData.status_id;
      this.addEditData.gantt_id = this.ganttId;
      this.addEditData.description = this.formData.description;
      this.addEditData.sort = this.formData.sort;
      this.addEditData.day = this.formData.day;


   
      
      this.save(this.addEditData);
    },

    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$emit('update-request');
      this.closeModal();
    },
    afterSuccessFromGetEditData(response) {
        
      this.formData = response.data;
      this.dataLoaded = true;
      this.formData.collaborator =
              response.data.collaborator.length > 0
                  ? collect(response.data.collaborator).pluck("id")
                  : [];
                  
                  
  
    
    },
  },
  mounted() {

    //this.formData.started_at = this.start ? moment(this.start, "DD.MM.YYYY").format('YYYY-MM-DD') : new Date();
    this.formData.started_at = this.end ? moment(this.end, "DD.MM.YYYY").format('YYYY-MM-DD') : new Date();
    this.formData.ended_at = this.end ? moment(this.end, "DD.MM.YYYY").format('YYYY-MM-DD') : new Date();
    

  },
};
</script>
<style scoped>
.show-change{
  display: none !important;
}
.show-change.show-change-active{
  display: flex !important;
}
</style>
